import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSubmissionFailureWrapper = styled.div``;

export const ResourceSubmissionFailureContainer = styled.div`
  max-width: 1153px;
  min-height: 768px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;

  margin: 0 auto;

  position: relative;

  & > svg {
    align-self: center;
  }

  ${BREAKPOINTS.tablet} {
    min-height: calc(100svh - var(--mobile-navbar-height) - 84px);
    padding: 32px;
  }
`;

export const ResourceSubmissionFailureIconContainer = styled.div`
  width: 70px;
  height: 70px;

  display: flex;
  justify-content: center;
  align-items: center;

  background: var(--color-data-company-foreground);
  border-radius: 100%;
`;

export const ResourceSubmissionFailureImage = styled.img.attrs({
  src: '/images/resource-submission/success.svg',
})`
  height: 297px;
`;

export const ResourceSubmissionFailureInformationContainer = styled.div``;

export const ResourceSubmissionFailureTitle = styled.h3`
  font-weight: 400;
  font-size: 32px;
  line-height: normal;
  text-align: center;

  color: var(--color-text);
`;

export const ResourceSubmissionFailureDescription = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  text-align: center;

  color: var(--color-text);
`;

export const ResourceSubmissionFailureStatus = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  color: var(--color-text);
`;

export const ResourceSubmissionFailureContactTeam = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-align: center;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
  cursor: pointer;
`;

export const ResourceSubmissionFailureStepsWrapper = styled.div`
  max-width: 816px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${BREAKPOINTS.tablet} {
    max-width: unset;
    flex-direction: column;
    align-items: center;

    gap: 16px;
  }

  position: relative;
`;

export const ResourceSubmissionFailureStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  position: relative;
`;

export const ResourceSubmissionFailureStepTitle = styled.h5`
  max-width: 154px;

  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  text-align: center;

  color: #323f5d;

  ${BREAKPOINTS.tablet} {
    max-width: 84px;
  }
`;

export const ResourceSubmissionFailureStepIconContainer = styled.div`
  width: 44px;
  height: 44px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: var(--color-primary);

  border-radius: 100%;
`;

export const ResourceSubmissionFailureStepsLine = styled.div`
  width: calc(100% - 110px);

  position: absolute;
  top: 22px;
  left: 55px;

  border-top: 1px dotted var(--color-primary);
`;

export const ResourceSubmissionFailureButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 32px;

  & > button {
    flex: 1;

    ${BREAKPOINTS.tablet} {
      width: 100%;
    }
  }

  ${BREAKPOINTS.tablet} {
    width: 100%;
    flex-direction: column;
    gap: 16px;
    margin-top: 32px;
  }
`;

export const ResourceSubmissionFailureShareButton = styled.button`
  min-width: 373px;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 10px;

  padding: 16px 32px 16px 48px;
  border-radius: 100px;
  border: 2px solid var(--color-primary);

  ${BREAKPOINTS.tablet} {
    min-width: unset;
    width: 100%;
  }
`;

export const ResourceSubmissionFailureShareButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  ${BREAKPOINTS.tablet} {
    font-size: 12px;
  }

  color: var(--color-text);
`;

export const ResourceSubmissionFailureCTA = styled.button`
  width: fit-content;
  height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 10px;

  padding: 16px 48px;

  border-radius: 100px;
  background: #000000;
`;

export const ResourceSubmissionFailureCTAText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: #ffffff;
`;
